import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';

/**
Componente che visualizza un badge con il suo stato. I children ammessi devono rappresentare solo testo.

Vedi [Design System di CGN - Badge](https://zeroheight.com/1b5e94371/p/501a37-badge/b/17c27a)
 */
function Badge(_a) {
    var { children = null, className = '', info = false, alarm = false, warning = false, positive = false, success = false, safe = false, outline = false } = _a, others = __rest(_a, ["children", "className", "info", "alarm", "warning", "positive", "success", "safe", "outline"]);
    return (jsx("span", Object.assign({ className: cns('badge', {
            'badge--info': info,
            'badge--alarm': alarm,
            'badge--warning': warning,
            'badge--positive': positive || success,
            'badge--safe': safe,
            'badge--outline': outline,
        }, className) }, others, { children: children })));
}

export { Badge as default };
